module.exports = __webpack_public_path__ + "img/fixresume.18b8c1fb.svg";